import { EXECUTIONER } from '../cards/attack/executioner';
import { HEAVY_CLEAVE } from '../cards/attack/heavy-cleave';
import { POWER_STRIKE } from '../cards/attack/power-strike';
import type { EnemyTemplate } from './template';

/** HEX-23 archetype ported (ADR-0015 §4, §15). Epic tier: 4×3 grid, 4 dice,
 * rare + at least one epic attack card. */
export const BONE_ARCHER: EnemyTemplate = {
  id: 'bone-archer',
  name: 'Bone Archer',
  glyph: '➶', // loosed arrow — the ranged archer
  tier: 'epic',
  hp: 36,
  loadout: [
    { card: HEAVY_CLEAVE, origin: { row: 0, col: 0 }, rotated: false },
    { card: EXECUTIONER, origin: { row: 2, col: 0 }, rotated: false },
    { card: POWER_STRIKE, origin: { row: 3, col: 0 }, rotated: false },
  ],
  drops: { gold: 10 },
};
